import React from 'react';
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider,
} from '@mui/material/styles';
import { Global, css } from '@emotion/react';
// eslint-disable-next-line import/extensions
import tokens from '@market/market-theme/js/tokens.json';
import { isDashboardMode } from 'helpers/search_parameter_helpers';

const px = (number) => `${number}px`;
const tokenValue = (path) =>
  path.split('.').reduce((prev, curr) => prev[curr], tokens);

export const BASE_THEME = {
  border: {
    radius: {
      base: '3px',
      large: '5px',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 820, // only override (matches ipad air)
      lg: 1280,
      xl: 1920,
    },
  },
  color: {
    blue: tokenValue('core.blue-fill.mode:light.color'),
    border: '#d9d9d9',
    gray: {
      5: '#f2f2f2',
      15: '#d9d9d9',
      30: '#b3b3b3',
      55: '#737373',
      90: '#1a1a1a',
      99: '#030303',
    },
    green: '#0bb634',
    greenDarker: '#03792c',
    lightBlue: '#e5f0ff',
    orange: '#f86932',
    red: '#df3320',
    white: '#ffffff',
    error: '#c00020',
    yellow: '#edff80',
  },
  components: {
    MuiDialog: {
      defaultProps: {
        'data-market-features': 'typography,html-styles',
      },
    },
  },
  type: {
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    fontSize: {
      tiny: px(tokenValue('core.type.paragraph.10.size')),
      small: px(tokenValue('core.type.paragraph.20.size')),
      base: px(tokenValue('core.type.paragraph.30.size')),
      medium: px(tokenValue('core.type.heading.20.size')),
      large: px(tokenValue('core.type.heading.30.size')),
    },
    lineHeight: {
      tiny: px(tokenValue('core.type.paragraph.10.leading')),
      small: px(tokenValue('core.type.paragraph.20.leading')),
      base: px(tokenValue('core.type.paragraph.30.leading')),
      medium: px(tokenValue('core.type.heading.20.leading')),
      large: px(tokenValue('core.type.heading.30.leading')),
    },
  },
  typography: {
    fontFamily: 'inherit',
    fontSize: tokenValue('core.type.paragraph.30.size'),
  },
};

const ShopTheme = ({ children, ...themeOptions }) => {
  const theme = createTheme({
    ...BASE_THEME,
    ...themeOptions,
  });

  const dashboardStyles = css`
    body {
      box-shadow: 0 0 0 0 !important;
      max-width: none !important;
    }
  `;

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        {isDashboardMode() && <Global styles={dashboardStyles} />}
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default ShopTheme;
